import React, { useState, useEffect } from 'react';
import styles from './History.module.css';

const History = () => {
    const [blocks, setBlocks] = useState([]);
    const [settings, setSettings] = useState({ title: 'ИСТОРИЯ' });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadHistory();
    }, []);

    const loadHistory = async () => {
        try {
            const [blocksRes, settingsRes] = await Promise.all([
                fetch('/api/content/history?field=blocks'),
                fetch('/api/content/history?field=settings')
            ]);

            const blocksData = await blocksRes.json();
            const settingsData = await settingsRes.json();

            let allBlocks = blocksData.data || [];
            allBlocks.sort((a, b) => (a.order || 0) - (b.order || 0));

            setBlocks(allBlocks);
            setSettings(settingsData.data || { title: 'ИСТОРИЯ' });
        } catch (error) {
            console.error('Ошибка загрузки истории:', error);
        } finally {
            setLoading(false);
        }
    };

    // Форматирование текста: **жирный** -> <strong>
    const formatText = (text) => {
        if (!text) return '';
        const parts = text.split(/(\*\*[^*]+\*\*)/g);
        return parts.map((part, i) => {
            if (part.startsWith('**') && part.endsWith('**')) {
                const boldText = part.slice(2, -2);
                return <strong key={i}>{boldText}</strong>;
            }
            // Разбиваем на параграфы по двойному переводу строки
            const paragraphs = part.split('\n\n');
            return paragraphs.map((para, j) => {
                if (para.trim()) {
                    return <p key={`${i}-${j}`}>{para}</p>;
                }
                return null;
            });
        });
    };

    if (loading) return null;
    if (blocks.length === 0) return null;

    return (
        <section id="history" className={styles.history}>
            <div className={styles.container}>
                <h2 className={styles.title}>{settings.title}</h2>

                {blocks.map((block, idx) => (
                    <div
                        key={block.id}
                        className={`${styles.block} ${styles[`image-${block.imagePosition}`]}`}
                    >
                        {block.imageUrl && (
                            <div className={styles.imageWrapper}>
                                <img
                                    src={`${block.imageUrl}`}
                                    alt={`История ${idx + 1}`}
                                    className={styles.image}
                                />
                            </div>
                        )}
                        <div className={styles.textWrapper}>
                            {formatText(block.text)}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default History;